import { render, staticRenderFns } from "./MessageTemplateList.vue?vue&type=template&id=f39ddbf4&scoped=true"
import script from "./MessageTemplateList.vue?vue&type=script&lang=js"
export * from "./MessageTemplateList.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateList.vue?vue&type=style&index=0&id=f39ddbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39ddbf4",
  null
  
)

export default component.exports